// Apps conectados (WEB-141, `spec/32-oauth-connect.md` §5.2 e §10): o seller vê quem tem
// acesso à conta e corta. Sem step-up: desconectar só tira acesso, não move dinheiro.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { API_KEYS_QUERY_KEY } from '../api/queries/api-keys.ts';
import {
  CONNECTED_APPS_QUERY_KEY,
  connectedAppsQueryOptions,
  disconnectApp,
} from '../api/queries/connected-apps.ts';
import { PageHeader } from '../components/app/page-header.tsx';
import { ConnectedAppsList } from '../features/connected-apps/connected-apps-list.tsx';

function ConnectedApps() {
  const queryClient = useQueryClient();
  const apps = useQuery(connectedAppsQueryOptions());

  const disconnect = useMutation({
    mutationFn: async (clientId: string) => disconnectApp(clientId),
    // A chave conectada foi revogada junto: a lista de chaves de API também muda.
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [CONNECTED_APPS_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [API_KEYS_QUERY_KEY] }),
      ]);
    },
  });

  return (
    <>
      <PageHeader title="Apps conectados" description="Quem tem acesso à sua conta" />
      <div className="max-w-[40rem]">
        <ConnectedAppsList
          apps={apps.data}
          error={apps.error}
          onRetry={() => {
            void apps.refetch();
          }}
          onDisconnect={async (clientId) => {
            await disconnect.mutateAsync(clientId);
          }}
          isDisconnecting={disconnect.isPending}
          disconnectError={disconnect.error}
          onDialogChange={() => {
            disconnect.reset();
          }}
        />
      </div>
    </>
  );
}

export const Route = createFileRoute('/app/settings/connected-apps/')({ component: ConnectedApps });
